var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.mandate_dashboard") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-button-group",
                        {
                          staticClass: "shadow",
                          staticStyle: { width: "100%", display: "flex" },
                        },
                        _vm._l(_vm.mainTabs, function (tab) {
                          return _c(
                            "b-button",
                            {
                              key: tab.id,
                              staticClass:
                                "responsive-button responsive-button-small",
                              staticStyle: { flex: "1" },
                              attrs: {
                                variant:
                                  _vm.mainTabIndex === tab.id
                                    ? "primary"
                                    : "secondary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.mainTabIndex = tab.id
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(tab.label) +
                                  "\n              "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-auto" }),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass:
                    "min-w-100 justify-content-start align-items-center",
                },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "span",
                        { staticClass: "filter-item-title d-block mb-1" },
                        [_vm._v(_vm._s(_vm.$t("Webheader.date_begin")))]
                      ),
                      _vm._v(" "),
                      _c("datetime-picker-custom", {
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.dateBeginFilter,
                        },
                        staticStyle: { padding: "0.35rem" },
                        attrs: {
                          format: "YYYY-MM-DD",
                          periodFull: "",
                          id: "filter-datebegin",
                          customInputParentClass: "filter-item-content",
                          customInputClass: "w-100",
                          maxLength: 19,
                          placeholderValue: _vm.$t(
                            "common.datepicker_format_date3"
                          ),
                          inputIcon: "fa-solid fa-calendar",
                          showTime: false,
                        },
                        model: {
                          value: _vm.dateBeginFilter,
                          callback: function ($$v) {
                            _vm.dateBeginFilter = $$v
                          },
                          expression: "dateBeginFilter",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "span",
                        { staticClass: "filter-item-title d-block mb-1" },
                        [_vm._v(_vm._s(_vm.$t("Webheader.date_end")))]
                      ),
                      _vm._v(" "),
                      _c("datetime-picker-custom", {
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.dateEndFilter,
                        },
                        staticStyle: { padding: "0.35rem" },
                        attrs: {
                          format: "YYYY-MM-DD",
                          periodFull: "",
                          id: "filter-dateend",
                          customInputParentClass: "filter-item-content",
                          customInputClass: "w-100",
                          maxLength: 19,
                          placeholderValue: _vm.$t(
                            "common.datepicker_format_date3"
                          ),
                          inputIcon: "fa-solid fa-calendar",
                          showTime: false,
                        },
                        model: {
                          value: _vm.dateEndFilter,
                          callback: function ($$v) {
                            _vm.dateEndFilter = $$v
                          },
                          expression: "dateEndFilter",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mainTabIndex === 0 || _vm.mainTabIndex === 1
                    ? _c("b-col", { attrs: { cols: "3" } }, [
                        _c(
                          "span",
                          { staticClass: "filter-item-title d-block mb-1" },
                          [_vm._v(_vm._s(_vm.$t("mandate.status_collection")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.statusFilter,
                                expression: "statusFilter",
                              },
                            ],
                            staticClass: "filter-item-content w-100",
                            staticStyle: { padding: "0.35rem" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.statusFilter = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "All" } }, [
                              _vm._v("──────────"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.statusOptions, function (s) {
                              return _c(
                                "option",
                                { key: s.value, domProps: { value: s.value } },
                                [_vm._v(_vm._s(_vm.$t(s.label)))]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mainTabIndex === 5
                    ? _c("b-col", { attrs: { cols: "3" } }, [
                        _c(
                          "span",
                          { staticClass: "filter-item-title d-block mb-1" },
                          [_vm._v("Type de parcours")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.journeyTypeFilter,
                                expression: "journeyTypeFilter",
                              },
                            ],
                            staticClass: "filter-item-content w-100",
                            staticStyle: { padding: "0.35rem" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.journeyTypeFilter = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "All" } }, [
                              _vm._v("──────────"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.journeyTypeOptions, function (j) {
                              return _c(
                                "option",
                                { key: j, domProps: { value: j } },
                                [_vm._v(_vm._s(j))]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mainTabIndex === 6
                    ? _c("b-col", { attrs: { cols: "3" } }, [
                        _c(
                          "span",
                          { staticClass: "filter-item-title d-block mb-1" },
                          [_vm._v("Recurrence")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.recurringFilter,
                                expression: "recurringFilter",
                              },
                            ],
                            staticClass: "filter-item-content w-100",
                            staticStyle: { padding: "0.35rem" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.recurringFilter = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "All" } }, [
                              _vm._v("──────────"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "Recurring" } }, [
                              _vm._v("Recurring only"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "OneOff" } }, [
                              _vm._v("One-off only"),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mainTabIndex !== 6
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex align-items-end justify-content-end",
                          attrs: {
                            cols:
                              _vm.mainTabIndex === 2 ||
                              _vm.mainTabIndex === 3 ||
                              _vm.mainTabIndex === 4
                                ? 6
                                : 3,
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2 mr-2",
                              attrs: { disabled: !_vm.hasInputFilter },
                              on: { click: _vm.clearFilterFields },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.rst")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              on: { click: _vm.applyFilters },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.srch")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mainTabIndex === 6
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex align-items-end justify-content-end",
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2 mr-2",
                              attrs: { disabled: !_vm.hasInputFilter },
                              on: { click: _vm.clearFilterFields },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.rst")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              on: { click: _vm.applyFilters },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.srch")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-auto mb-4" }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-card",
                        { staticClass: "position-relative" },
                        [
                          _c("h3", { staticClass: "text-center mb-4" }, [
                            _vm._v(_vm._s(_vm.chartTitle)),
                          ]),
                          _vm._v(" "),
                          _vm.activateSpinner ? _c("spinner") : _vm._e(),
                          _vm._v(" "),
                          !_vm.activateSpinner
                            ? [
                                _vm.mainTabIndex === 0 || _vm.mainTabIndex === 1
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "justify-content-center align-items-center",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                attrs: { cols: "12", md: "7" },
                                              },
                                              [
                                                _vm.hasData
                                                  ? _c("pie-chart", {
                                                      ref: "pieChart",
                                                      staticStyle: {
                                                        "max-height": "400px",
                                                      },
                                                      attrs: {
                                                        "chart-data":
                                                          _vm.currentPieData,
                                                        options:
                                                          _vm.chartOptions,
                                                      },
                                                    })
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-center",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "noResult",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                attrs: { cols: "12", md: "5" },
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass: "legend-list",
                                                  },
                                                  _vm._l(
                                                    _vm.currentLabels,
                                                    function (label, idx) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key: idx,
                                                          staticClass:
                                                            "legend-item-dashboard",
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "legend-dot",
                                                            style: {
                                                              backgroundColor:
                                                                _vm
                                                                  .currentColors[
                                                                  idx
                                                                ],
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "legend-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(label)
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "legend-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .currentValues[
                                                                    idx
                                                                  ]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.mainTabIndex === 0
                                          ? _c(
                                              "div",
                                              [
                                                _c("hr", {
                                                  staticClass: "mx-auto my-4",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "h5",
                                                  { staticClass: "mb-3" },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.dashboard.mandates_by_transaction_type_schema"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      {
                                                        staticClass: "mb-4",
                                                        attrs: {
                                                          cols: "12",
                                                          lg: "7",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "volume-chart",
                                                          },
                                                          [
                                                            _c("bar-chart", {
                                                              attrs: {
                                                                "chart-data":
                                                                  _vm.mandateTypeSchemaChartData,
                                                                options:
                                                                  _vm.mandateTypeSchemaChartOptions,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      {
                                                        attrs: {
                                                          cols: "12",
                                                          lg: "5",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "table-responsive",
                                                          },
                                                          [
                                                            _c("b-table", {
                                                              staticClass:
                                                                "mb-0",
                                                              attrs: {
                                                                striped: "",
                                                                hover: "",
                                                                small: "",
                                                                items:
                                                                  _vm.mandateTypeSchemaTableItems,
                                                                fields:
                                                                  _vm.mandateTypeSchemaTableFields,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "cell(percentage)",
                                                                      fn: function (
                                                                        data
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  data.value
                                                                                ) +
                                                                                  " %"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  1143066860
                                                                ),
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.mainTabIndex === 1
                                          ? _c(
                                              "div",
                                              [
                                                _c("hr", {
                                                  staticClass: "mx-auto my-4",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "h5",
                                                  { staticClass: "mb-3" },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.dashboard.collection_performance"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  { staticClass: "mb-4" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      {
                                                        staticClass: "mb-3",
                                                        attrs: {
                                                          cols: "12",
                                                          md: "6",
                                                          lg: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collection-kpi-card",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mandate.dashboard.total_amount"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.formatCollectionAmount(
                                                                        _vm
                                                                          .collectionKpis
                                                                          .totalAmount
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      {
                                                        staticClass: "mb-3",
                                                        attrs: {
                                                          cols: "12",
                                                          md: "6",
                                                          lg: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collection-kpi-card",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mandate.dashboard.paid_amount"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.formatCollectionAmount(
                                                                        _vm
                                                                          .collectionKpis
                                                                          .paidAmount
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      {
                                                        staticClass: "mb-3",
                                                        attrs: {
                                                          cols: "12",
                                                          md: "6",
                                                          lg: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collection-kpi-card",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mandate.dashboard.payment_rate"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .collectionKpis
                                                                        .paymentRate
                                                                    ) +
                                                                    " %\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      {
                                                        staticClass: "mb-3",
                                                        attrs: {
                                                          cols: "12",
                                                          md: "6",
                                                          lg: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collection-kpi-card",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mandate.dashboard.rejection_rate"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .collectionKpis
                                                                        .rejectionRate
                                                                    ) +
                                                                    " %\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      {
                                                        staticClass: "mb-3",
                                                        attrs: {
                                                          cols: "12",
                                                          md: "6",
                                                          lg: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collection-kpi-card",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mandate.dashboard.error_rate"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collection-kpi-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .collectionKpis
                                                                        .errorRate
                                                                    ) +
                                                                    " %\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      {
                                                        staticClass: "mb-4",
                                                        attrs: {
                                                          cols: "12",
                                                          lg: "7",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass: "mb-3",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.dashboard.amount_by_collection_status"
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "volume-chart",
                                                          },
                                                          [
                                                            _c("bar-chart", {
                                                              attrs: {
                                                                "chart-data":
                                                                  _vm.collectionStatusAmountChartData,
                                                                options:
                                                                  _vm.collectionStatusAmountChartOptions,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      {
                                                        attrs: {
                                                          cols: "12",
                                                          lg: "5",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass: "mb-3",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.dashboard.collection_status_summary"
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "table-responsive",
                                                          },
                                                          [
                                                            _c("b-table", {
                                                              staticClass:
                                                                "mb-0",
                                                              attrs: {
                                                                striped: "",
                                                                hover: "",
                                                                small: "",
                                                                items:
                                                                  _vm.collectionStatusTableItems,
                                                                fields:
                                                                  _vm.collectionStatusTableFields,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "cell(percentage)",
                                                                      fn: function (
                                                                        data
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  data.value
                                                                                ) +
                                                                                  " %"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  1143066860
                                                                ),
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.mainTabIndex === 2
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "b-alert",
                                          {
                                            staticClass: "journey-description",
                                            attrs: {
                                              show: "",
                                              variant: "light",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.dashboard.signature_error_reporting_description"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "form-accordion",
                                          {
                                            attrs: {
                                              title: _vm.$t(
                                                "mandate.dashboard.operational_summary"
                                              ),
                                              isTitleUpperCase: false,
                                            },
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              { staticClass: "mb-4" },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mb-3 mb-md-0",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "kpi-card",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "kpi-label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "mandate.dashboard.signature_attempts"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "kpi-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .signatureErrorKpis
                                                                  .totalAttempts
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mb-3 mb-md-0",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "kpi-card",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "kpi-label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "mandate.dashboard.failed_signatures"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "kpi-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .signatureErrorKpis
                                                                  .failedAttempts
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mb-3 mb-md-0",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "kpi-card",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "kpi-label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "mandate.dashboard.Échec_rate"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "kpi-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .signatureErrorKpis
                                                                  .ÉchecRate
                                                              ) + " %"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "kpi-card kpi-card-warning",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "kpi-label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "mandate.dashboard.main_recurring_issue"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "kpi-value kpi-value-small",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .signatureErrorKpis
                                                                  .mainIssue
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      lg: "8",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "error-chart",
                                                      },
                                                      [
                                                        _c(
                                                          "horizontal-bar-chart",
                                                          {
                                                            attrs: {
                                                              "chart-data":
                                                                _vm.signatureErrorChartData,
                                                              options:
                                                                _vm.signatureErrorChartOptions,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mt-4 mt-lg-0",
                                                    attrs: {
                                                      cols: "12",
                                                      lg: "4",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "error-summary-panel",
                                                      },
                                                      [
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass: "mb-3",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "mandate.dashboard.operational_summary"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "summary-line",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.dashboard.resolved_automatically"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .signatureErrorKpis
                                                                    .autoResolved
                                                                ) + " %"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "summary-line",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.dashboard.requires_agent_action"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .signatureErrorKpis
                                                                    .agentAction
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "summary-line",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.dashboard.most_impacted_channel"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .signatureErrorKpis
                                                                    .mainChannel
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "summary-line",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.dashboard.average_resolution_time"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .signatureErrorKpis
                                                                    .avgResolutionTime
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "form-accordion",
                                          {
                                            attrs: {
                                              title: _vm.$t(
                                                "mandate.dashboard.customer_signature_error_details"
                                              ),
                                              isTitleUpperCase: false,
                                            },
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              { staticClass: "mt-4" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "h5",
                                                      { staticClass: "mb-3" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.customer_signature_error_details"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "table-responsive",
                                                      },
                                                      [
                                                        _c("b-table", {
                                                          staticClass: "mb-0",
                                                          attrs: {
                                                            striped: "",
                                                            hover: "",
                                                            small: "",
                                                            items:
                                                              _vm.signatureErrorTableItems,
                                                            fields:
                                                              _vm.signatureErrorTableFields,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "cell(severity)",
                                                                fn: function (
                                                                  data
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "b-badge",
                                                                      {
                                                                        attrs: {
                                                                          variant:
                                                                            _vm.severityVariant(
                                                                              data.value
                                                                            ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              data.value
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "cell(status)",
                                                                fn: function (
                                                                  data
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "b-badge",
                                                                      {
                                                                        attrs: {
                                                                          variant:
                                                                            _vm.errorStatusVariant(
                                                                              data.value
                                                                            ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              data.value
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3949202097
                                                          ),
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.mainTabIndex === 4
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "overview-section-title",
                                          },
                                          [
                                            _vm._v(
                                              "1. " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.dashboard.issued_mandates_status"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                attrs: { cols: "12", md: "5" },
                                              },
                                              [
                                                _vm.hasData
                                                  ? _c("pie-chart", {
                                                      staticStyle: {
                                                        "max-height": "260px",
                                                      },
                                                      attrs: {
                                                        "chart-data":
                                                          _vm.currentPieData,
                                                        options:
                                                          _vm.chartOptions,
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                attrs: { cols: "12", md: "7" },
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass: "legend-list",
                                                  },
                                                  _vm._l(
                                                    _vm.currentLabels,
                                                    function (label, idx) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key: idx,
                                                          staticClass:
                                                            "legend-item-dashboard",
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "legend-dot",
                                                            style: {
                                                              backgroundColor:
                                                                _vm
                                                                  .currentColors[
                                                                  idx
                                                                ],
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "legend-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(label)
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "legend-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .currentValues[
                                                                    idx
                                                                  ]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "mx-auto my-4",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "overview-section-title",
                                          },
                                          [
                                            _vm._v(
                                              "2. " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.dashboard.representations_success_rate"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-responsive",
                                                  },
                                                  [
                                                    _c("b-table", {
                                                      staticClass: "mb-0",
                                                      attrs: {
                                                        striped: "",
                                                        hover: "",
                                                        small: "",
                                                        items:
                                                          _vm.representationTableItems,
                                                        fields:
                                                          _vm.representationTableFields,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "cell(successRate)",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "b-badge",
                                                                  {
                                                                    attrs: {
                                                                      variant:
                                                                        _vm.representationVariant(
                                                                          data
                                                                            .item
                                                                            .successRateValue
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data.value
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2028937505
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "mx-auto my-4",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "overview-section-title",
                                          },
                                          [
                                            _vm._v(
                                              "3. " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.dashboard.recovery_performance"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.recovery_rate"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.recoveryKpis
                                                              .rate
                                                          ) + " %"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.average_recovery_delay"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.recoveryKpis
                                                              .avgDelayDays
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.dashboard.days"
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-warning",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.unpaid_amount_period"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value kpi-value-small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.recoveryKpis
                                                              .unpaidAmountLabel
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "mx-auto my-4",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "overview-section-title",
                                          },
                                          [
                                            _vm._v(
                                              "4. " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.dashboard.usage_statistics_audit_trail"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-responsive",
                                                  },
                                                  [
                                                    _c("b-table", {
                                                      staticClass: "mb-0",
                                                      attrs: {
                                                        striped: "",
                                                        hover: "",
                                                        small: "",
                                                        items:
                                                          _vm.auditTableItems,
                                                        fields:
                                                          _vm.auditTableFields,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "mx-auto my-4",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "overview-section-title",
                                          },
                                          [
                                            _vm._v(
                                              "5. " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.dashboard.fraud_alerts_events"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-3" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-2",
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-compact",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.fraud_rate"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.fraudKpis
                                                              .fraudRate
                                                          ) + " %"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-2",
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-compact",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.total_amount_at_risk"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value kpi-value-small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.fraudKpis
                                                              .totalAmountLabel
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-2",
                                                attrs: { cols: "12", md: "4" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-compact",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.detected_by_sncf_bank"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value kpi-value-small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.fraudKpis
                                                              .sncfCount
                                                          ) +
                                                            " / " +
                                                            _vm._s(
                                                              _vm.fraudKpis
                                                                .bankCount
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-responsive",
                                                  },
                                                  [
                                                    _c("b-table", {
                                                      staticClass:
                                                        "mb-0 clickable-rows",
                                                      attrs: {
                                                        striped: "",
                                                        hover: "",
                                                        small: "",
                                                        items:
                                                          _vm.fraudTableItems,
                                                        fields:
                                                          _vm.fraudTableFields,
                                                      },
                                                      on: {
                                                        "row-clicked":
                                                          _vm.goToFraudCase,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "cell(severity)",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "b-badge",
                                                                  {
                                                                    attrs: {
                                                                      variant:
                                                                        _vm.fraudSeverityVariant(
                                                                          data.value
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data.value
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1003217599
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.mainTabIndex === 5
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.total_events"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.techLogKpis
                                                              .total
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.success_rate"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.techLogKpis
                                                              .successRate
                                                          ) + " %"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Échecs sur la période"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.techLogKpis
                                                              .ÉchecCount
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-warning",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.top_technical_cause"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value kpi-value-small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.techLogKpis
                                                              .topCause
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "mb-3" },
                                                  [
                                                    _vm._v(
                                                      "Étapes du parcours - volume de succès et d’échecs"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "volume-chart",
                                                  },
                                                  [
                                                    _c("bar-chart", {
                                                      attrs: {
                                                        "chart-data":
                                                          _vm.techJourneyChartData,
                                                        options:
                                                          _vm.techJourneyChartOptions,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mt-4" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "mb-3" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.dashboard.technical_event_log"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-responsive tech-log-table",
                                                  },
                                                  [
                                                    _c("b-table", {
                                                      staticClass: "mb-0",
                                                      attrs: {
                                                        striped: "",
                                                        hover: "",
                                                        small: "",
                                                        items:
                                                          _vm.techLogTableItems,
                                                        fields:
                                                          _vm.techLogTableFields,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "cell(status)",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "b-badge",
                                                                  {
                                                                    attrs: {
                                                                      variant:
                                                                        data.value ===
                                                                        "Success"
                                                                          ? "success"
                                                                          : "danger",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data.value
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                          {
                                                            key: "cell(errorCode)",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                data.value
                                                                  ? _c("code", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          data.value
                                                                        )
                                                                      ),
                                                                    ])
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "-"
                                                                      ),
                                                                    ]),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2967334157
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.mainTabIndex === 6
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "overview-section-title",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.dashboard.rejects_rtransactions_by_motif"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-2",
                                                attrs: { cols: "12", md: "6" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-compact",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.total_rejects_period"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.rejectKpis.total.toLocaleString(
                                                              "en-US"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-2",
                                                attrs: { cols: "12", md: "6" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-compact",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.top_return_code"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value kpi-value-small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.rejectKpis
                                                              .topMotif
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-5" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "volume-chart",
                                                  },
                                                  [
                                                    _c("bar-chart", {
                                                      ref: "motifChart",
                                                      attrs: {
                                                        "chart-data":
                                                          _vm.motifChartData,
                                                        options:
                                                          _vm.motifChartOptions,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "mx-auto my-4",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.total_rejects_unpaid"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.unpaidRejectKpis
                                                              .totalCount
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.total_amount"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value kpi-value-small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.unpaidRejectKpis
                                                              .totalAmountLabel
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-warning",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.reject_rate"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.unpaidRejectKpis
                                                              .rejectRate
                                                          ) + " %"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "mb-3" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.dashboard.by_follow_up_status"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("pie-chart", {
                                                  ref: "followUpChart",
                                                  staticStyle: {
                                                    "max-height": "360px",
                                                  },
                                                  attrs: {
                                                    "chart-data":
                                                      _vm.followUpChartData,
                                                    options: _vm.chartOptions,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mt-4" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "mb-3" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.dashboard.unpaid_reject_detail"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-responsive",
                                                  },
                                                  [
                                                    _c("b-table", {
                                                      staticClass: "mb-0",
                                                      attrs: {
                                                        striped: "",
                                                        hover: "",
                                                        small: "",
                                                        items:
                                                          _vm.unpaidRejectTableItems,
                                                        fields:
                                                          _vm.unpaidRejectTableFields,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "cell(recurringLabel)",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "b-badge",
                                                                  {
                                                                    attrs: {
                                                                      variant:
                                                                        data.value ===
                                                                        "Oui"
                                                                          ? "warning"
                                                                          : "secondary",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data.value
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        730898289
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c(
                                          "b-alert",
                                          {
                                            staticClass: "journey-description",
                                            attrs: {
                                              show: "",
                                              variant: "light",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.dashboard.journey_monitoring_description"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.unique_users"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.journeyKpis
                                                              .uniqueUsers
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.average_processing_time_page"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatDuration(
                                                              _vm.journeyKpis
                                                                .avgTimeMs
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3 mb-md-0",
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "kpi-card" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.average_abandonment_rate"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.journeyKpis
                                                              .avgAbandonmentRate
                                                          ) + " %"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                attrs: { cols: "12", md: "3" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "kpi-card kpi-card-warning",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "kpi-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.dashboard.overall_application_status"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "kpi-value kpi-value-small",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.journeyKpis
                                                              .mainFriction
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "journey-chart",
                                                  },
                                                  [
                                                    _c("horizontal-bar-chart", {
                                                      attrs: {
                                                        "chart-data":
                                                          _vm.journeyChartData,
                                                        options:
                                                          _vm.journeyChartOptions,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "mt-4" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "mb-3" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "mandate.dashboard.aggregated_anonymized_data"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-responsive",
                                                  },
                                                  [
                                                    _c("b-table", {
                                                      staticClass: "mb-0",
                                                      attrs: {
                                                        striped: "",
                                                        hover: "",
                                                        small: "",
                                                        items:
                                                          _vm.journeyTableItems,
                                                        fields:
                                                          _vm.journeyTableFields,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "cell(abandonmentRate)",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "b-badge",
                                                                  {
                                                                    attrs: {
                                                                      variant:
                                                                        _vm.abandonmentVariant(
                                                                          data
                                                                            .item
                                                                            .abandonmentRateValue
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          data.value
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                          {
                                                            key: "cell(status)",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "b-badge",
                                                                  {
                                                                    attrs: {
                                                                      variant:
                                                                        _vm.statusVariant(
                                                                          data.value
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          data.value
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2367295913
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-end",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm.mainTabIndex === 0 ||
                                  _vm.mainTabIndex === 1 ||
                                  _vm.mainTabIndex === 6
                                    ? _c(
                                        "div",
                                        { staticClass: "export-wrapper" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "btnFilter_2",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  _vm.showExportModal =
                                                    !_vm.showExportModal
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-light fa-upload",
                                              }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("mandate.export")
                                                  ) +
                                                  "\n\n                    "
                                              ),
                                              _c("i", {
                                                staticClass: "fa-light ml-2",
                                                class: _vm.showExportModal
                                                  ? "fa-chevron-up"
                                                  : "fa-chevron-down",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.showExportModal
                                            ? _c(
                                                "div",
                                                { staticClass: "export-menu" },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "export-menu-item",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.chooseDashboardExport(
                                                            "csv"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-file-csv mr-2",
                                                      }),
                                                      _vm._v(
                                                        "\n                      CSV\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "export-menu-item",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.chooseDashboardExport(
                                                            "pdf"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-file-pdf mr-2",
                                                      }),
                                                      _vm._v(
                                                        "\n                      PDF\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "b-button",
                                        {
                                          staticClass: "btnFilter_2",
                                          on: { click: _vm.exportData },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa-light fa-upload",
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("mandate.export")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }